export { GenericHero } from './generic-hero'
